import {
  ResumeAnalysisServiceResponse,
  ResumeAnalysisResponseType,
} from '@iteach/types'
import axios from 'axios'

// @ts-ignore
import * as pdfjsLib from 'pdfjs-dist/webpack'

// export const DEV_ENV_URL =
//   'https://b7p42e2ori7muvm3hgm5mysgoa0hpxul.lambda-url.us-east-2.on.aws'
// export const LOCAL_URL =
//   'http://localhost:2138/api/v1/resumes/analyze-resume-no-db'

const RESUME_API_URL = process.env.REACT_APP_RESUME_API_URL as string

export type TextAnalysisResultType =
  | {
      success: true
      message: string
      originalText: string
      data: ResumeAnalysisResponseType
    }
  | {
      success: false
      originalText: string
      message: string
      code: 'ERROR' | 'RATE_LIMIT'
    }

export const analyzeText = async (
  text: string,
): Promise<TextAnalysisResultType> => {
  try {
    console.log('Starting analysis call...')
    const response = await axios.post(
      RESUME_API_URL,
      {
        text: text,
      },
      {
        headers: {
          'Content-Type': 'application/json',
          'x-api-key': 'test',
        },
      },
    )

    if (!response.data) {
      throw new Error('No data returned')
    }
    const data = response.data as ResumeAnalysisServiceResponse
    if (!data.success) {
      throw new Error('Service call failed')
    }

    console.log('Analyze text result from server: ', data)

    return {
      success: true,
      message: 'Success',
      originalText: text,
      data: data.analysisResult,
    }
  } catch (e: any) {
    console.log('Error analyzing text: ', e)
    if (e.response && e.response.status === 429) {
      return {
        success: false,
        originalText: text,
        message: 'Error analyzing text',
        code: 'RATE_LIMIT',
      }
    }
    return {
      success: false,
      originalText: text,
      message: 'Error analyzing text',
      code: 'ERROR',
    }
  }
}

export const textFromFile = (file: File): Promise<string | null> => {
  if (!file) return Promise.resolve(null)

  return new Promise((resolve, _reject) => {
    // Create a FileReader to read the PDF binary data
    const reader = new FileReader()
    reader.onload = async (e) => {
      // Convert the ArrayBuffer to a PDF.js-friendly format
      const typedArray = new Uint8Array(e.target!.result as ArrayBuffer)
      // @ts-ignore - Type 'ArrayBuffer' is not assignable to type 'string'.
      const pdf = await pdfjsLib.getDocument(typedArray).promise

      let structuredText: string[] = []

      // Limiting the pages processed to 3 or less
      const numPages = Math.min(3, pdf.numPages)

      for (let pageNum = 1; pageNum <= numPages; pageNum++) {
        const page = await pdf.getPage(pageNum)
        const textContent = await page.getTextContent()

        let lastY: number | null = null

        // Page indicator
        structuredText.push(`\n\n==== Page ${pageNum} ====\n\n`)

        for (const item of textContent.items) {
          const { transform, str } = item
          const [, , , , x, y] = transform

          if (lastY !== null && Math.abs(y - lastY) > 2) {
            structuredText.push('\n')
          }

          if (lastY !== null && Math.abs(y - lastY) > 10) {
            structuredText.push('\n\n')
          }

          structuredText.push(str)
          lastY = y
        }
      }

      const finalText = structuredText.join(' ')

      return resolve(finalText)
    }

    reader.readAsArrayBuffer(file)
  })
}
